export default __webpack_public_path__ + "static/compass-d04b0736de9be9159c1d99ee59153d3f.svg";